<template>
  <div>
    <router-view></router-view>
    <footer>
      <cookie-law theme="blood-orange">
        <div slot="message">
          <p>
            {{ $t("message.rgpd", { value: "default" }) }}
            <a href="#" @click="dialog = true">Click here</a>
          </p>
        </div>
      </cookie-law>
    </footer>

    <v-dialog
      v-model="dialog"
      max-width="1100"
      overlay-color="#003441"
      overlay-opacity="0.8"
    >
      <v-card class=" pt-5">
        <v-card-text class="text-justify">
          <h2 class="text-center mb-4">Notice of Use and Privacy Policy</h2>
          <p>
            Within the framework of the contract, Akiem provides the customer
            with its customer portal MyFleetHub.
          </p>
          <div>
            The personal data required to create a user profile are the
            following
            <ul>
              <li>Name and first name</li>
              <li>Professional email address</li>
              <li>Professional phone number</li>
              <li>Job title</li>
            </ul>
          </div>
          <p>
            This data is accessible only to authorized Akiem personnel, who are
            subject to the duty of confidentiality and will be kept by default
            for the duration of the contract with Akiem. It is hosted in France
            and is not transmitted outside the EU under any circumstances.
          </p>
          <p>
            On this Portal, we do not use cookies. Thus, none of your personal
            data will be collected during your connection session or stored
            after it has ended. You will be expressly asked for consent if you
            wish to use the "satisfaction survey" feature
          </p>
          <p>
            The use of the data, information and/or documents available on this
            Portal is done under the entire and sole responsibility of the
            Portal user, who assumes all the consequences that may result from
            it, without Akiem being held responsible for this, and without
            recourse against Akiem
          </p>
          <p>
            Akiem cannot be held responsible for any damage of any kind
            resulting from the interpretation or use of the information and/or
            documents available on this Website.
          </p>
          <p>
            Akiem undertakes to respect in a fair and transparent manner the
            legislation on personal data protection, in particular the General
            Data Protection Regulation (the "GDPR"). Akiem has put in place
            technical and organizational measures to ensure that the User's data
            is protected against unauthorized access as well as any other
            security risk and computer vulnerability.
          </p>
          <p>
            You have a wide range of rights, including the right to information
            about the personal data we keep (Article 15 of the GDPR),
            rectification (Article 16 of the GDPR), deletion (Article 17 of the
            GDPR), restriction of processing (Article 18 of the GDPR), data
            portability (Article 20 of the GDPR) and opposition to processing
            (Article 21 of the GDPR), especially in the case of direct
            advertising which you can exercise by emailing dpo@akiem.com or
            datenschutz@akiem-technik.com.
          </p>
          <p>
            The Portal is normally accessible 24 hours a day and 7 days a week,
            except in case of force majeure or an event beyond Akiem's control
            and subject to possible breakdowns and maintenance interventions
            necessary for the proper functioning of the Portal, to Users with an
            Internet access. Akiem reserves the right to interrupt, at any time
            without prior notice, or to temporarily suspend or modify access to
            all or part of the Website, in order to ensure its maintenance, or
            for any other reason, without the interruption giving rise to any
            obligation or compensation.
          </p>

          <hr class="mb-4" />

          <h2 class="text-center mb-4">
            Notice d’utilisation et politique de confidentialité
          </h2>
          <p>
            Dans le cadre d’exécution du contrat, Akiem met à disposition du
            client, son portail client MyFleetHub.
          </p>
          <div>
            Les données personnelles nécessaires à la création d’un profil
            utilisateurs sont les suivantes
            <ul>
              <li>Nom et prénom</li>
              <li>Adresse email professionnelle</li>
              <li>N° téléphone professionnel</li>
              <li>fonction</li>
            </ul>
          </div>
          <p>
            Ces données ne sont accessibles qu’aux seules personnes habilitées à
            akiem, lesquelles sont soumises au devoir de confidentialité et
            seront conservées par défaut pendant toute la durée du contrat avec
            Akiem. Elles sont hébergées en France et ne sont en aucun cas
            transmises hors de l’UE.
          </p>
          <p>
            Sur ce Portail, nous n'utilisons pas de cookies. Ainsi, aucune de
            vos données personnelles ne sera collectée durant votre session de
            connexion ni stockée après à la fin de celle-ci. Un consentement
            vous sera expressément demandé dans le cas où vous souhaiteriez
            utiliser la fonctionnalité « enquête de satisfaction ».
          </p>
          <p>
            L’utilisation des données, informations et/ou documents disponibles
            sur ce Portail se fait sous l’entière et seule responsabilité de
            l’utilisateur du Portail, qui assume la totalité des conséquences
            pouvant en découler, sans que la responsabilité d’Akiem puisse être
            recherchée à ce titre, et sans recours contre Akiem.
          </p>
          <p>
            Akiem cannot be held responsible for any damage of any kind
            resulting from the interpretation or use of the information and/or
            documents available on this Website.
          </p>
          <p>
            Akiem ne pourra en aucun cas être tenu responsable de tout dommage
            de quelque nature qu’il soit résultant d’une interprétation ou de
            l’utilisation des informations et/ou documents disponibles sur ce
            Portail. Akiem s’engage à respecter de manière équitable et
            transparente la législation sur la protection des données
            personnelles, en particulier le Règlement Général sur la Protection
            des Données (le « RGPD »). Akiem a mis en place les mesures
            techniques et organisationnelles pour veiller à ce que les données
            de l’Utilisateur soient protégées contre les accès non-autorisés
            ainsi que tout autre risque de sécurité et de vulnérabilité
            informatique.
          </p>
          <p>
            Vous disposez d'un large éventail de droits, notamment le droit
            d'information sur les données personnelles que nous conservons
            (article 15 du RGPD), de rectification (article 16 du RGPD), de
            suppression (article 17 du RGPD), de limitation du traitement
            (article 18 du RGPD), de portabilité des données (article 20 du
            RGPD) et d'opposition au traitement (article 21 du RGPD), en
            particulier dans le cas de la publicité directe que vous pouvez
            exercer en vous adressant par courriel à dpo@akiem.com ou
            datenschutz@akiem-technik.com.
          </p>
          <p>
            Le Portail est normalement accessible 24 heures sur 24 et 7 jours
            sur 7, sauf en cas de force majeure ou d’un événement hors du
            contrôle de Akiem et sous réserve des éventuelles pannes et
            interventions de maintenance nécessaires au bon fonctionnement du
            Portail, aux Utilisateurs disposant d’un accès à internet. Akiem se
            réserve la possibilité d’interrompre, à tout moment sans préavis, ou
            de suspendre momentanément ou de modifier l’accès à tout ou partie
            du Portail, afin d’en assurer la maintenance, ou pour toute autre
            raison, sans que l’interruption n’ouvre droit à aucune obligation ni
            indemnisation.
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "App",
  data: () => ({
    dialog: false,
  }),
  methods: {
    ...mapActions("config", {
      actionOffline: "loadSiteState",
    }),
  },
  components: {
    CookieLaw,
  },
    computed: {
    ...mapGetters("config", {
      getterLoginStatus: "isOffline",
    })
  },
};
</script>
<style scoped>
</style>
